import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import React, { Component } from 'react'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import List from '../../../components/Purchasing/SupplierRegistration/List'

const { Content } = Layout

class SupplierRegistration extends Component {
  render() {
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb items={[{ text: 'Vendor' }, { text: 'Registration' }]} />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card title={<h1>Vendor Registration</h1>}>
            <List {...this.props} />
          </Card>
        </Row>
      </Content>
    )
  }
}

export default SupplierRegistration
